import React from 'react';

interface RadioButtonProps {
  selected: boolean;
  onPress: () => void;
  label: string;
}

const RadioButton = ({ selected, onPress, label }: RadioButtonProps) => {
  const bgcolor = selected ? 'bg-[#DA291C]' : 'bg-[#C6C6C8]';
  const borderColor = selected ? 'border-[#DA291C]' : 'border-[#C6C6C8]';

  return (
    <div
      onClick={onPress}
      className="flex flex-row items-center mb-4 cursor-pointer"
    >
      <div
        className={`w-6 h-6 rounded-full border-2 ${borderColor} mr-2 flex justify-center items-center`}
      >
        {selected && <div className={`w-3 h-3 rounded-full ${bgcolor}`} />}
      </div>
      <div className="flex-1">
        <div className="text-sm text-black">{label}</div>
      </div>
    </div>
  );
};

export default RadioButton;
